import React, { Component } from 'react';
export class VirtualTBodyComponent extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div 
				className={"custom-tbody"}
				style={{
					...this.props.style,
					minWidth: `${this.props.rowMinWidth}px`,
				}}
				{...this.props.rest}
			>
			<VirtualList
			  className='virtual-list'
			  width='100%'
			  height={363}
			  itemCount={this.props.children[0].length}
			  itemSize={27} 
			  renderItem={({index, style}) =>
			  		<div key={index} style={style}>
			  			{this.props.children[0][index]}
			  		</div>
				}
			/>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/table/custom-tbody.js